<div class="container-fluid">

    <app-page-header header="{{pageTitle}}"
     tooltip="{{pageTitle}}"
     description="Assists in verifying the availability and proper operation of services"
    [showBreadcrumb]="true"
  [breadcrumb]="breadcrumb">
    </app-page-header>
    <div class="health-status-container">
        <div class="release-toolbar-row">
            <p class="release-title">
                Release: {{releaseTitle}}
            </p>
        
        <mat-form-field appearance="fill">
            <mat-label><b>Select Environment:</b></mat-label>
            <mat-select [(ngModel)]="selectedEnv" [disabled]="isStaticEnvironmentSelect" (selectionChange)="onEnvironmentChange()"
            panelClass="releaseForm-environments-custom-panel">
                <!-- Environment options -->
                <mat-option *ngFor="let env of filteredEnvironments" [value]="env">
                    {{ env.environmentName }}
                </mat-option>
            </mat-select>
            <mat-icon matSuffix style="font-size: 18px; margin-bottom: -5px;" matTooltip="{{ configEnvInfoMsg }}" matTooltipPosition="right"
                aria-hidden="true" matTooltipClass="ey-custom-tooltip">info</mat-icon>
        </mat-form-field>
        
        <button mat-icon-button class="refresh-btn" [disabled]="refreshDisabled" matTooltip="{{refMsg}}" matTooltipClass="ey-custom-tooltip" (click)="refreshTable()">
            <mat-icon class="refresh-icon">refresh</mat-icon>
        </button>
    </div>
    <!-- for agGrid height: 625px;  -->
    <div id="health-status">
        <ag-grid-angular #agGrid [style]="styleChipDiv"  [rowData]="filteredRowData" [columnDefs]="columnDefs"
            [infiniteInitialRowCount]="infiniteInitialRowCount" [overlayNoRowsTemplate]="overlayNoRowsTemplate"
            class="ag-theme-material"  [defaultColDef]="defaultColDef"
            [suppressMenuHide]="false" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>

</div>